import React from "react";
import { Clock3, MessageCircle, UserRound } from "lucide-react";

function ContactStats({ conversation, contact }) {
  const messageCount = conversation?.unread_count ?? conversation?.message_count ?? 0;
  const sessionTime =  conversation?.session_duration ?? conversation?.duration ?? "-";
  const lastActivity = conversation?.last_message_at ?? conversation?.updated_at ?? conversation?.created_at ?? null;
  const assignedUser = conversation?.assigned_user?.name ?? conversation?.user?.name ?? contact?.assigned_user?.name ?? "Unassigned";

  const formatLastActivity = (date) => {
    if (!date) {
      return "-";
    }
    const value = new Date(date);
    if (Number.isNaN(value.getTime())) {
      return "-";
    }
    return value.toLocaleDateString("en-IN", {
      day: "2-digit",
      month: "short",
    });
  };

  return (
    <div className="grid grid-cols-3 gap-2">
      <StatCard
        icon={MessageCircle}
        label="Messages"
        value={messageCount}
      />

      <StatCard
        icon={Clock3}
        label="Session"
        value={sessionTime}
      />

      <StatCard
        icon={UserRound}
        label="Assigned"
        value={assignedUser}
        truncate
      />

      {/* Last Activity */}
      <div className="col-span-3 flex min-w-0 items-center justify-between rounded-[13px] border border-[#e1e9e7] bg-white px-3 py-2.5 shadow-[0_3px_10px_rgba(15,43,66,0.03)] transition-all duration-200 hover:border-[#d2e1dc] hover:shadow-[0_5px_14px_rgba(15,43,66,0.05)] dark:border-dark-border dark:bg-dark-card dark:hover:border-dark-primary/30 dark:hover:bg-dark-soft-blue/40">
        <div className="flex min-w-0 items-center gap-2.5">
          <div className="relative flex h-8 w-8 shrink-0 items-center justify-center overflow-hidden rounded-[10px] border border-[#d9e7e2] bg-[#f0f7f4] text-[#4b8374] dark:border-dark-border dark:bg-dark-soft-blue dark:text-dark-primary">
            <span className="pointer-events-none absolute left-1 top-1 h-2.5 w-4 rounded-full bg-white/70 blur-[2px]" />
            <Clock3 size={14} strokeWidth={1.9} className="relative z-10"/>
          </div>
          <div className="min-w-0">
            <p className="text-[9px] font-semibold uppercase tracking-[0.08em] text-text-muted dark:text-dark-text-muted">
              Last Activity
            </p>

            <p className="mt-1 truncate text-[12px] font-semibold tracking-[-0.01em] text-text-secondary dark:text-dark-text-secondary">
              {formatLastActivity(lastActivity)}
            </p>
          </div>
        </div>

        {/* Status */}
        <span className="ml-2 shrink-0 rounded-full border border-emerald-100 bg-emerald-50 px-2.5 py-1 text-[9px] font-bold text-emerald-700 dark:border-dark-border dark:bg-dark-soft-blue dark:text-dark-primary">
          Active
        </span>
      </div>
    </div>
  );
}

function StatCard({ icon: Icon, label, value, truncate = false }) {
  return (
    <div className="group min-w-0 rounded-[13px] border border-[#e1e9e7] bg-white px-2.5 py-2.5 shadow-[0_3px_10px_rgba(15,43,66,0.03)] transition-all duration-200 hover:border-[#d2e1dc] hover:shadow-[0_5px_14px_rgba(15,43,66,0.05)] dark:border-dark-border dark:bg-dark-card dark:hover:border-dark-primary/30 dark:hover:bg-dark-soft-blue/40">
      <div className="flex min-w-0 items-center gap-2">
        <div className="relative flex h-7 w-7 shrink-0 items-center justify-center overflow-hidden rounded-[9px] border border-[#d9e7e2] bg-[#f0f7f4] text-[#4b8374] transition-all duration-200 group-hover:bg-white dark:border-dark-border dark:bg-dark-soft-blue dark:text-dark-primary dark:group-hover:bg-dark-card">
          <span className="pointer-events-none absolute left-1 top-1 h-2.5 w-4 rounded-full bg-white/80 blur-[2px]" />
          <Icon
            size={13}
            strokeWidth={1.9}
            className="relative z-10 sm:h-[14px] sm:w-[14px]"
          />
        </div>

        <span className="min-w-0 truncate text-[9px] font-semibold uppercase tracking-[0.08em] text-text-muted dark:text-dark-text-muted">
          {label}
        </span>
      </div>

      <p
        className={`mt-2 min-w-0 truncate text-[12px] font-semibold leading-tight tracking-[-0.01em] text-text-secondary sm:text-[13px] dark:text-dark-text-secondary ${truncate ? "truncate" : ""
          }`}
        title={truncate ? value : undefined}
      >
        {value || "-"}
      </p>
    </div>
  );
}

export default ContactStats;
